import { getRouteApi } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { useGetUserUtils } from '~/data/user';

import { ReleaseStatus } from '~/modules/releaseStatus';

import { Tabs, type TabDefinition } from '@vestigas/ui/molecules';

import { type ReleaseTab } from './constants';
import { ReleaseNotes } from './ReleaseNotes';

const ReleaseNotesRoute = getRouteApi('/(main)/release-notes/');

export function ReleaseNotesPage() {
  const { t } = useTranslation('release');
  const { tab: activeTab } = ReleaseNotesRoute.useSearch();
  const navigate = ReleaseNotesRoute.useNavigate();
  const { UserUtils } = useGetUserUtils();

  const tabs: TabDefinition[] = [
    {
      content: () => (
        <div className="flex min-h-0 flex-1 flex-col">
          <ReleaseNotes />
        </div>
      ),
      label: t(($) => $.tabs.notes),
      value: 'notes',
      views: [],
    },
  ];

  // Release status is Vestigas support only. `isVestigasAccount()` is deliberately
  // not used here: it also matches the demo and sales logins.
  if (UserUtils.isVestigasSupportAccount()) {
    tabs.push({
      content: () => (
        <div className="flex min-h-0 flex-1 flex-col">
          <ReleaseStatus />
        </div>
      ),
      label: t(($) => $.tabs.status),
      value: 'status',
      views: [],
    });
  }

  // `?tab=status` is reachable by hand, so fall back when the tab is hidden.
  const value = tabs.some((tab) => tab.value === activeTab)
    ? activeTab
    : 'notes';

  return (
    <div className="flex h-full w-full flex-col gap-6 p-4 md:p-6">
      <Tabs
        tabs={tabs}
        value={value}
        onChange={(_event, nextTab) =>
          void navigate({
            replace: true,
            search: (previous) => ({
              ...previous,
              tab: nextTab as ReleaseTab,
            }),
          })
        }
      />
    </div>
  );
}
